export default "__VITE_ASSET__DbQ5aySl__"